<div class="l-main" role="main">
    <div class="l-container">

        <div class="l-content">
            
            <div class="panel-pane bg-transparent align-center">

                <ul class="list--pipe">

                    <li><a href="">Visit the UC Davis directory</a></li>

                    <li><a href="https://org.ucdavis.edu/odr">Update my UC Davis directory listing</a></li>

                    <!--<li><a href="http://localhost/directory/">See All Departments</a></li>-->

                </ul>

            </div>
            <div class="panel-pane box">
                <!-- ********** Main content section ********** -->
                <div id="main_section" role="main">
                    <!-- Center column (primary content) -->
                    <div id="center_column">
                        <div id="center_column_inner_wrap">

                            <div class="repeating_content_block"></div>

                            <div id="directory_results_wrapper">
                                <div class="test" *ngFor="let peopleDetails of peopleList; let i = index">
                                    <div *ngIf="i == 1">
                                        Additional Listing(s):
                                    </div>
                                    <table border="0" cellpadding="2" cellspacing="2" width="100%">
                                        <TR VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Name</th>
                                            <td align="left"><b>{{peopleDetails.name}}</b></td>
                                            <td align="left"><span class="vcard"><strong>Pronouns:</strong>&nbsp;</span> <Span>{{peopleDetails.pronouns}}</Span></td>
                                        </TR>
                                        <TR VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">E-mail: </th>
                                            <td colspan="1" bgcolor="#EFE5BF" align="left"><a
                                                    href="mailto:{{peopleDetails.mail}}">{{peopleDetails.mail}}</a></td>
                                            <td colspan="1" bgcolor="#EFE5BF" align="left"><img src="assets/images/vcard.gif" border="0"
                                                    alt="vCard: Add listing to your Address Book"> <span class="vcard"><strong>vCard:</strong>&nbsp;<a
                                                        class="vcard" [vcdDownloadVCard]="peopleDetails.vCard"  [encoding]="vCardEncoding.none"
                                                        title="Add listing to your Address Book">Add listing to your Address Book</a></span>&nbsp;<a
                                                        [vcdDownloadVCard]="peopleDetails.vCard" ><img
                                                        src="assets/images/help.gif" border="0" alt="vCard Help" title="vCard Help"></a>
                                            </td>
                                        </TR>
                                        <TR *ngIf="peopleDetails.title !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Title</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.title}}</td>
                                        </TR>
                                        <TR *ngIf="peopleDetails.department !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Department</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.department}}</td>
                                        </TR>
                                        <TR *ngIf="peopleDetails.street !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Address</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.street}}</td>
                                        </TR>
                                        <TR *ngIf="peopleDetails.city !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">City/State/Zip</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.city}} {{peopleDetails.state}} {{peopleDetails.zip}}</td>
                                        </TR>
                                        <TR *ngIf="peopleDetails.telephoneNumber !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Phone</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.telephoneNumber}}</td>
                                         </TR>
                                         <TR *ngIf="peopleDetails.fax !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Fax</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.fax}}</td>
                                        </TR>
                                        <TR *ngIf="peopleDetails.cellular !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Cellular</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.cellular}}</td>
                                        </TR>
                                        <TR *ngIf="peopleDetails.pager !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Pager</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.pager}}</td>
                                        </TR>
                                        <TR *ngIf="peopleDetails.tdd !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">TDD</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.tdd}}</td>
                                        </TR>   
                                        <TR *ngIf="peopleDetails.website !==null" VALIGN="top">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Web Site</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left"><a 
                                                href="{{peopleDetails.website}}">{{peopleDetails.website}}</a></td>
                                        </TR>
                                        <TR VALIGN="top" *ngIf="peopleDetails.is_student == '1'">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Major</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.major}}</td>
                                        </TR>
                                        <TR VALIGN="top" *ngIf="peopleDetails.is_student == '1'">
                                            <th width="15%" bgcolor="#BCC5CF" align="left">Student Level</th>
                                            <td colspan="2" bgcolor="#EFE5BF" align="left">{{peopleDetails.student_level}}</td>
                                        </TR>
                                    </table>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <!-- End center column -->

                    <!-- Optional right column -->

                    <!-- End optional right column -->
                </div>
                <!-- ********** End main content ********** -->
            </div>
        </div>
        <!--end .l-content-->

    </div>

</div>
<!--End role=main-->
<p class="privacy">
    <strong>Privacy Notice:</strong> This campus directory is the property
    of <a href="https://www.ucdavis.edu">
        <font size="3" color="navy">University
            of California, Davis.</font>
    </a> To protect the privacy of individuals listed
    herein, in accordance with the State of California Information
    Practices Act, this directory may not be used, rented, distributed, or
    sold for commercial purposes.
</p>